import type { CSSProperties } from "react";

import { Icon, type IconName } from "./Icon";
import "./Kpi.css";

type Tone = "default" | "featured" | "success" | "warning" | "danger";

type Props = {
  icon: IconName;
  tone?: Tone;
  label: string;
  value: string;
  delta?: { value: string; dir: "up" | "down" };
  sub?: string;
  iconBg?: string;
  iconFg?: string;
};

const TONE_CLASS: Record<Tone, string> = {
  default: "kpi-card",
  featured: "kpi-card featured",
  success: "kpi-card tone-success",
  warning: "kpi-card tone-warning",
  danger: "kpi-card tone-danger",
};

export function Kpi({ icon, tone = "default", label, value, delta, sub, iconBg, iconFg }: Props) {
  const iconStyle: CSSProperties | undefined =
    iconBg || iconFg ? { background: iconBg, color: iconFg } : undefined;
  return (
    <div className={TONE_CLASS[tone]}>
      <div className="kpi-icon" style={iconStyle}>
        <Icon name={icon} size={18} />
      </div>
      <div className="kpi-label">{label}</div>
      <div className="kpi-val">{value}</div>
      {(delta || sub) && (
        <div className="kpi-foot">
          {delta && (
            <span className={`kpi-delta ${delta.dir}`}>
              <Icon name={delta.dir === "up" ? "trending-up" : "alert-triangle"} size={11} />
              {delta.value}
            </span>
          )}
          {sub && <span>{sub}</span>}
        </div>
      )}
    </div>
  );
}
